import React from 'react'
import { css, cx } from '@emotion/css'
import { WithTooltip } from '../../design-system'
import { OverflowDetector } from '../../legacy-design-system/overflow-detector'
import { bodyCss } from '../../legacy-design-system/text'

const truncateCss = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const textCss = cx(
  bodyCss,
  css`
    font-size: 12px;
  `,
  truncateCss
)

interface MetadataFiltersListProps {
  readonly filters?: string[]
  readonly filterListStyle?: string
}

interface MetadataFiltersListState {
  readonly checkOverflowing: boolean
}

export class MetadataFiltersList extends React.Component<
  MetadataFiltersListProps,
  MetadataFiltersListState
> {
  public constructor(props) {
    super(props)
    this.state = {
      checkOverflowing: false
    }
  }

  public componentDidMount() {
    window.addEventListener('resize', () => {
      this.updateOverflowing(true)
    })
  }

  public render() {
    const { filters, filterListStyle } = this.props

    if (!filters || filters.length === 0) {
      return null
    }

    const filtersContent = filters.map((f) => f).join(', ')

    return (
      <OverflowDetector>
        {({ doesOverflowParent, registerElement }) => {
          const FiltersList = () => (
            <span
              ref={registerElement}
              className={
                !!filterListStyle ? cx(truncateCss, filterListStyle) : textCss
              }
              children={filtersContent}
            />
          )

          return doesOverflowParent() ? (
            <WithTooltip
              placement="bottom-start"
              renderTooltipContent={() => filtersContent}
              children={() => <FiltersList />}
            />
          ) : (
            <FiltersList />
          )
        }}
      </OverflowDetector>
    )
  }

  private updateOverflowing = (checkOverflowing: boolean) =>
    this.setState({ checkOverflowing })
}
